import { useEffect } from 'react';
import { createProject } from '../core/project';
import { loadLastProject, saveProject } from '../services/persistence';
import { useEditorStore } from '../store/editorStore';

export function useAutosaveRecovery() {
  useEffect(() => {
    let active = true;
    void loadLastProject().then(async (project) => {
      if (!active) return;
      const next = project ?? createProject();
      if (!project) await saveProject(next, true).catch(() => undefined);
      useEditorStore.getState().replaceProject(next);
    }).catch(() => useEditorStore.getState().setReady(true));
    return () => { active = false; };
  }, []);
}
